<template>
    <div class="outbound-plan-page">
        <!-- 搜索与筛选区域 -->
        <el-card class="search-card">
            <el-form :inline="true" :model="searchForm" class="search-form" size="mini">
                <el-form-item label="出库单号" prop="outboundNumber">
                    <el-input v-model="searchForm.outboundNumber" placeholder="输入出库单号" clearable
                        maxLength="30"></el-input>
                </el-form-item>
                <!-- <el-form-item label="流水号" prop="numId">
                    <el-input v-model="searchForm.numId" placeholder="输入流水号" clearable maxLength="20"></el-input>
                </el-form-item> -->
                <el-form-item label="产品名称" prop="productName">
                    <el-input v-model="searchForm.productName" placeholder="输入产品名称" clearable maxLength="50"></el-input>
                </el-form-item>
                <el-form-item label="所属功能间" prop="roomId">
                    <el-select v-model="searchForm.roomId" placeholder="选择功能间" clearable>
                        <el-option label="全部" value=""></el-option>
                        <el-option label="热菜间" value="1"></el-option>
                        <el-option label="凉菜间" value="2"></el-option>
                        <el-option label="面点间" value="3"></el-option>
                        <el-option label="包装间" value="4"></el-option>
                        <el-option label="仓储间" value="5"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="出库时间" prop="dateTime">
                    <el-date-picker v-model="searchForm.dateTime" type="daterange" range-separator="至"
                        start-placeholder="开始时间" end-placeholder="结束时间" clearable value-format="yyyy-MM-dd"
                        :picker-options="{
                            disabledDate: (time) => time.getTime() > Date.now() + 8.64e7
                        }"></el-date-picker>
                </el-form-item> -->
                <el-form-item>
                    <el-button type="primary" @click="fetchOutboundPlans" icon="el-icon-search">查询</el-button>
                    <el-button @click="resetSearch" icon="el-icon-refresh">重置</el-button>
                    <!-- <el-button type="warning" @click="exportOutboundList" icon="el-icon-download">导出</el-button> -->
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 出库计划列表区域 -->
        <el-card class="outbound-list-card">
            <el-table :data="outboundList" border stripe height="60vh" v-loading="loading"
                element-loading-text="正在加载出库计划数据..." element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" @row-dblclick="viewDetail"
                :header-cell-style="{ background: '#f5f7fa', fontWeight: '500', fontSize: '14px' }">
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="outboundNumber" label="出库单号" width="160" align="center"></el-table-column>
                <el-table-column prop="numId" label="流水号" width="120" align="center"></el-table-column>
                <el-table-column prop="productName" label="产品名称" width="180" align="center"></el-table-column>
                <el-table-column prop="operationNum" label="出库数量" width="120" align="center">
                    <template #default="scope">
                        <span class="num-text">{{ scope.row.operationNum || 0 }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="unit" label="单位" width="80" align="center"></el-table-column>
                <el-table-column prop="room" label="所属功能间" width="140" align="center"></el-table-column>
                <el-table-column prop="taskNumber" label="关联任务号" align="center"></el-table-column>
                <el-table-column prop="orderNumber" label="关联订单号" align="center"></el-table-column>
                <el-table-column prop="dateTime" label="出库时间" align="center"></el-table-column>
                <el-table-column label="操作" width="140" align="center">
                    <template #default="scope">
                        <el-button size="mini" type="primary" icon="el-icon-view" @click="viewDetail(scope.row)"
                            title="查看详情">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 分页组件：独立容器，避免被card遮挡 -->
        <div class="pagination-container">
            <el-pagination ref="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize" :total="total"
                layout="total, sizes, prev, pager, next, jumper" background size="mini">
            </el-pagination>
        </div>

        <!-- 出库计划详情弹窗 -->
        <el-dialog title="出库计划详情" :visible.sync="detailVisible" width="650px" :close-on-click-modal="false"
            :append-to-body="true" top="50px" :z-index="9999">
            <div class="detail-content" v-if="currentOutbound">
                <el-row :gutter="30">
                    <el-col :span="12">
                        <el-descriptions :column="1" border :label-style="{ fontWeight: '500' }">
                            <el-descriptions-item label="出库单号">{{ currentOutbound.outboundNumber
                            }}</el-descriptions-item>
                            <el-descriptions-item label="流水号">{{ currentOutbound.numId }}</el-descriptions-item>
                            <el-descriptions-item label="产品编码">{{ currentOutbound.productCode || '无'
                            }}</el-descriptions-item>
                            <el-descriptions-item label="产品名称">{{ currentOutbound.productName }}</el-descriptions-item>
                            <!-- <el-descriptions-item label="产品规格">{{ currentOutbound.spec || '无' }}</el-descriptions-item> -->
                            <el-descriptions-item label="出库数量">{{ currentOutbound.operationNum || 0 }} {{
                                currentOutbound.unit
                                || '件' }}</el-descriptions-item>
                        </el-descriptions>
                    </el-col>
                    <el-col :span="12">
                        <el-descriptions :column="1" border :label-style="{ fontWeight: '500' }">
                            <el-descriptions-item label="所属功能间">{{ currentOutbound.room || '无' }}</el-descriptions-item>
                            <el-descriptions-item label="关联任务号">{{ currentOutbound.taskNumber || '无'
                            }}</el-descriptions-item>
                            <el-descriptions-item label="关联订单号">{{ currentOutbound.orderNumber || '无'
                            }}</el-descriptions-item>
                            <el-descriptions-item label="出库时间">{{ currentOutbound.dateTime || '无'
                            }}</el-descriptions-item>
                            <!-- <el-descriptions-item label="操作人">{{ currentOutbound.operatorName || '无'
                                }}</el-descriptions-item>
                            <el-descriptions-item label="备注">{{ currentOutbound.remark || '无' }}</el-descriptions-item> -->
                        </el-descriptions>
                    </el-col>
                </el-row>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="detailVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// 导入出库计划列表接口
import { getOutboundPlans, exportOutboundPlans } from '@/api/OutboundPlan';

export default {
    name: 'OutboundPlanManagement',
    components: {},
    data() {
        return {
            // 搜索表单数据
            searchForm: {
                outboundNumber: '',
                numId: '',
                productName: '',
                productCode: '',
                roomId: '',
                dateTime: []
            },
            // 功能间映射表（解决ID和名称匹配问题）
            roomMap: {

            },
            // 列表数据
            outboundList: [], // 当前页展示的数据
            allOutboundList: [], // 保存全部数据（用于前端分页）
            total: 0, // 总条数（全部数据的长度）
            currentPage: 1, // 当前页码
            pageSize: 10, // 每页条数
            loading: false, // 加载状态
            // 详情弹窗
            detailVisible: false,
            currentOutbound: null
        };
    },
    mounted() {
        // 页面加载后请求数据，并确保分页组件渲染
        this.fetchOutboundPlans().then(() => {
            this.$nextTick(() => {
                console.log('分页组件渲染状态：', this.$refs.pagination ? '已渲染' : '未渲染');
            });
        });
    },
    methods: {
        /**
         * 手动分页：根据当前页码和页大小截取数据
         */
        handlePagination() {
            // 计算截取起始/结束索引
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            // 截取当前页数据
            this.outboundList = this.allOutboundList.slice(startIndex, endIndex);
            // 强制更新视图，确保数据生效
            this.$forceUpdate();
        },

        /**
         * 前端搜索过滤：基于全部数据过滤（接口不支持搜索时生效）
         */
        filterData() {
            let filteredList = [...this.allOutboundList];
            // 出库单号过滤
            if (this.searchForm.outboundNumber) {
                filteredList = filteredList.filter(item =>
                    item.outboundNumber?.includes(this.searchForm.outboundNumber.trim())
                );
            }
            // 流水号过滤
            if (this.searchForm.numId) {
                filteredList = filteredList.filter(item =>
                    item.numId?.includes(this.searchForm.numId.trim())
                );
            }
            // 产品名称过滤
            if (this.searchForm.productName) {
                filteredList = filteredList.filter(item =>
                    item.productName?.includes(this.searchForm.productName.trim())
                );
            }
            // 功能间过滤（核心修复：兼容ID和名称两种匹配方式）
            if (this.searchForm.roomId) {
                filteredList = filteredList.filter(item => {
                    // 方式1：匹配roomId（兼容数字/字符串）
                    const roomIdMatch = item.roomId != null && item.roomId.toString() === this.searchForm.roomId;
                    // 方式2：匹配room名称（直接通过ID映射名称）
                    const roomNameMatch = item.room === this.roomMap[this.searchForm.roomId];
                    // 满足任一方式即匹配
                    return roomIdMatch || roomNameMatch;
                });
            }
            // 时间范围过滤
            if (this.searchForm.dateTime.length === 2) {
                const [startTime, endTime] = this.searchForm.dateTime;
                filteredList = filteredList.filter(item => {
                    if (!item.dateTime) return false;
                    const itemTime = item.dateTime.split(' ')[0] || '';
                    return itemTime >= startTime && itemTime <= endTime;
                });
            }
            return filteredList;
        },

        /**
         * 调用接口获取全部出库计划数据
         */
        async fetchOutboundPlans() {
            this.loading = true;
            try {
                // 构造请求参数（包含搜索条件）
                const params = {
                    userId: localStorage.getItem('userId') || '',
                    outboundNumber: this.searchForm.outboundNumber.trim(),
                    numId: this.searchForm.numId.trim(),
                    productName: this.searchForm.productName.trim(),
                    roomId: this.searchForm.roomId || '',
                    startTime: this.searchForm.dateTime[0] || '',
                    endTime: this.searchForm.dateTime[1] || ''
                };

                // 调用接口获取全部数据
                const response = await getOutboundPlans(params);
                // 保存原始全部数据（接口返回的原始数据）
                this.allOutboundList = response.data || [];

                // 前端过滤数据（叠加前端搜索条件）
                const filteredList = this.filterData();
                // 更新总条数和当前页数据
                this.total = filteredList.length;
                // 重新赋值过滤后的数据，用于分页
                this.allOutboundList = filteredList;
                // 执行分页
                this.handlePagination();



                // // 兜底：如果无数据，添加测试数据验证分页功能
                // if (this.total === 0) {
                //     this.allOutboundList = Array.from({ length: 50 }).map((_, i) => ({
                //         id: i + 1,
                //         outboundNumber: `OUT${202512000 + i}`,
                //         numId: `FLOW${1000 + i}`,
                //         productName: `测试产品${i + 1}`,
                //         operationNum: 10 + i,
                //         unit: '件',
                //         roomId: (i % 5) + 1,
                //         room: ['热菜间', '凉菜间', '面点间', '包装间', '仓储间'][i % 5],
                //         taskNumber: `TASK${9000 + i}`,
                //         orderNumber: `ORDER${8000 + i}`,
                //         dateTime: `2025-12-${(i % 30) + 1} 10:${i % 60}:${i % 60}`,
                //         operatorName: '测试操作员'
                //     }));
                // 重新过滤测试数据（确保功能间筛选生效）
                //     const testFilteredList = this.filterData();
                //     this.total = testFilteredList.length;
                //     this.allOutboundList = testFilteredList;
                //     this.handlePagination();
                //     console.log('已添加测试数据，总条数：', this.total);
                // }

            } catch (error) {
                console.error('出库计划列表请求异常:', error);
                this.$message.error('网络异常，无法加载出库计划数据');
                this.allOutboundList = [];
                this.outboundList = [];
                this.total = 0;
            } finally {
                this.loading = false;
            }
        },

        /**
         * 重置搜索条件
         */
        resetSearch() {
            this.searchForm = {
                outboundNumber: '',
                numId: '',
                productName: '',
                productCode: '',
                roomId: '',
                dateTime: []
            };
            this.currentPage = 1; // 重置为第一页
            this.fetchOutboundPlans();
        },

        /**
         * 分页大小改变
         */
        handleSizeChange(size) {
            this.pageSize = size;
            this.currentPage = 1; // 页大小改变，重置为第一页
            this.$nextTick(() => {
                this.handlePagination(); // 重新分页
            });
        },

        /**
         * 当前页码改变
         */
        handleCurrentChange(page) {
            this.currentPage = page;
            this.$nextTick(() => {
                this.handlePagination(); // 重新分页
            });
        },

        /**
         * 查看出库计划详情
         */
        viewDetail(row) {
            console.log(row);
            this.currentOutbound = { ...row }; // 深拷贝避免数据联动
            this.detailVisible = true;
            console.log(this.detailVisible);
        },

        /**
         * 导出出库计划列表
         */
        async exportOutboundList() {
            this.loading = true;
            try {
                const exportParams = {
                    outboundNumber: this.searchForm.outboundNumber.trim(),
                    numId: this.searchForm.numId.trim(),
                    productName: this.searchForm.productName.trim(),
                    roomId: this.searchForm.roomId || '',
                    startTime: this.searchForm.dateTime[0] || '',
                    endTime: this.searchForm.dateTime[1] || '',
                    userId: localStorage.getItem('userId') || ''
                };

                const response = await exportOutboundPlans(exportParams);
                if (response.success) {
                    // 处理文件下载（适配Excel文件流）
                    const blob = new Blob([response.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `出库计划列表_${new Date().toLocaleDateString().replace(/\//g, '')}.xlsx`;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                    this.$message.success('导出成功');
                } else {
                    this.$message.error(response.message || '导出失败');
                }
            } catch (error) {
                console.error('导出出库计划异常:', error);
                this.$message.error('网络异常，导出失败');
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.outbound-plan-page {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
    box-sizing: border-box;

    .search-card {
        margin-bottom: 20px;
        border-radius: 8px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

        .search-form {
            display: flex;
            flex-wrap: wrap;
            gap: 16px;
            padding: 15px 0;

            .el-form-item {
                margin-bottom: 10px;
            }
        }
    }

    .outbound-list-card {
        border-radius: 8px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
        margin-bottom: 15px; // 与分页组件拉开间距

        .el-table {
            border-radius: 8px 8px 0 0;
            overflow: hidden;
            height: calc(100vh - 280px);

            .num-text {
                color: #1989fa;
                font-weight: 500;
            }
        }
    }

    // 分页容器样式：强制显示，确保不被遮挡
    .pagination-container {
        display: flex !important;
        justify-content: flex-end !important;
        align-items: center !important;
        margin-top: 10px !important;
        padding: 15px 20px !important;
        background-color: #fff !important;
        border-radius: 8px !important;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05) !important;
        height: 60px !important;
        box-sizing: border-box !important;
        z-index: 999 !important;
    }

    .detail-content {
        padding: 10px 0;

        .el-descriptions {
            margin-bottom: 15px;
        }

        .el-descriptions__item {
            padding: 10px 16px;
        }
    }

    .dialog-footer {
        text-align: center;
    }
}

// 适配小屏幕
@media (max-width: 1440px) {
    .outbound-plan-page {
        .outbound-list-card .el-table {
            height: calc(100vh - 320px);
        }
    }
}
</style>